export default Object.freeze({
  CORDOVA: process.env.VUE_APP_CORDOVA === '1',
  ICOOL: {
    BACKEND_HOST: process.env.VUE_APP_BACKEND_HOST,
    LOGIN_URL: process.env.VUE_APP_LOGIN_URL,
    LOGOUT_URL: 'user/logout',
    API: {
      SNAPSHOTS_PATH: 'api/v1/user/snapshots',
      SNAPSHOT_PATH: snapshotId => `api/v1/user/snapshots/${snapshotId}`,
      DEFAULT_SNAPSHOT_PATH: snapshotId => `api/v1/user/snapshots/${snapshotId}/default`,
      PLACES_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/places`,
      SERVICE_GROUPS_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/service-groups`,
      SERVICES_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/services`,
      ACTORS_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/actors`,
      VARS_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/vars`,
      USER_DATA_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/detail`,
      USER_SCENES_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/scenes`,
      USER_SCENE_PATH: (snapshotId, sceneId) => `api/v1/user/snapshot/${snapshotId}/scenes/${sceneId}`,
      USER_SCENE_SERVICE_PATH: (sceneId, serviceId) => `api/v1/user/scenes/${sceneId}/service/${serviceId}`,
      USER_SCENES_VARS_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/scenes/vars`,
      USER_SCENE_VAR_UPDATE_PATH: varId => `api/v1/user/scenes/vars/${varId}`,
      USER_SPACEPLANS_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/spaceplans`,
      USER_SPACEPLAN_PATH: (snapshotId, spaceplanId) => `api/v1/user/snapshot/${snapshotId}/spaceplans/${spaceplanId}`,
      USER_SPACEPLANS_ITEMS_PATH: planId => `api/v1/user/spaceplans/${planId}/items`,
      USER_SPACEPLANS_ITEMS_UPDATE_PATH: (planId, itemId) => `api/v1/user/spaceplans/${planId}/items/${itemId}`,
      SPACEPLAN_ASSIGNMENTS_PATH: planId => `api/v1/user/spaceplans/${planId}/assignments`,
      SPACEPLAN_ASSIGNMENT_PATH: (planId, itemId) => `api/v1/user/spaceplans/${planId}/assignments/${itemId}`,
      SCENE_ASSIGNMENTS_PATH: sceneId => `api/v1/user/scenes/${sceneId}/assignments`,
      SCENE_ASSIGNMENT_PATH: (sceneId, itemId) => `api/v1/user/scenes/${sceneId}/assignments/${itemId}`,
      USER_NOTIFICATIONS_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/notifications`,
      USER_NOTIFICATION_PATH: (snapshotId, notificationId) => `api/v1/user/snapshot/${snapshotId}/notifications/${notificationId}`,
      USER_NOTIFICATION_MEMBER_PATH: (snapshotId, memberId) => `api/v1/user/snapshot/${snapshotId}/notification-members/${memberId}`,
      USER_NOTIFICATION_SUBSCRIPTIONS_PATH: (snapshotId, notificationId) => `api/v1/user/snapshot/${snapshotId}/notifications/${notificationId}/subscriptions`,
      USERS_PATH: snapshotId => `api/v1/snapshot/${snapshotId}/users`,
      PAID_SUBSCRIPTION_PATH: snapshotId => `api/v1/snapshot/${snapshotId}/paid-subscription`,
      PROJECT_SETTINGS_PATH: snapshotId => `api/v1/snapshot/${snapshotId}/project-settings`,
      USERS_ME_PATH: snapshotId => `api/v1/snapshot/${snapshotId}/users/me`,
      USER_PATH: (snapshotId, userId) => `api/v1/snapshot/${snapshotId}/users/${userId}`,
      USER_SERVICE_PERMISSIONS_PATH: (snapshotId, userId) => `api/v1/snapshot/${snapshotId}/users/${userId}/service-permissions`,
      USER_AUTH_TOKEN_PATH: 'api/v1/user/auth-token',
      SERVICE_PERMISSION_PATH: (snapshotId, servicePermissionId) => `api/v1/snapshot/${snapshotId}/service-permissions/${servicePermissionId}`,
      VAR_ITEM_PATH: (snapshotId, varItemId) => `api/v1/snapshot/${snapshotId}/vars/${varItemId}`,
      LOG_EVENTS_PATH: snapshotId => `api/v1/snapshot/${snapshotId}/arguments/log-events`,
      FAVORITE_OBJECTS_PATH: snapshotId => `api/v1/user/snapshot/${snapshotId}/favorite-objects`,
      FAVORITE_OBJECT_PATH: (snapshotId, contentType, objectId) => `api/v1/user/snapshot/${snapshotId}/favorite-objects/${contentType}/${objectId}`,
      CLOUD_STATUS: snapshotId => `api/v1/snapshot/${snapshotId}/cloud/status`,
      PROJECTS_ACTIVE_SNAPSHOT_DATA: projectId => `api/v1/projects/${projectId}/snapshot/active/data`,
      SERVICE_SETTINGS_DATA: (snapshotId, serviceId) => `api/v1/snapshot/${snapshotId}/services/${serviceId}/settings/data`,
      ACTION_PATH: snapshotId => `api/v1/snapshot/${snapshotId}/action`,
      HELPDESK_TICKET: 'api/v1/helpdesk/ticket',
      PLACE_PATH: (snapshotId, placeId) => `api/v1/user/snapshot/${snapshotId}/places/${placeId}`,
      SERVICE_PATH: (snapshotId, serviceId) => `api/v1/user/snapshot/${snapshotId}/services/${serviceId}`,
      METRICS_PATH: (snapshotId) => `api/v1/user/snapshot/${snapshotId}/metrics`,
      FCM_DEVICES_PATH: 'api/v1/device/gcm',
      APNS_DEVICES_PATH: 'api/v1/device/apns',
    },
    WEBSOCKET_SERVER: process.env.VUE_APP_WEBSOCKET_SERVER,
    WEBSOCKET_DEBUG: process.env.VUE_APP_WEBSOCKET_DEBUG === '1',
    ENABLE_WEBSOCKETS: process.env.VUE_APP_ENABLE_WEBSOCKETS === '1',
    FORCE_CONNECTION_OK: process.env.VUE_APP_FORCE_CONNECTION_OK === '1',
    DISABLE_UPDATING_VARS: process.env.VUE_APP_DISABLE_UPDATING_VARS === '1',
    ACTORS_ROLES: {
      SWITCH: 'switch',
      BRIGHTNESS: 'brightness',
      RGB: 'rgb',
      HEAT: 'heat',
    },
  },
  LANGUAGES: {
    1: 'en',
    2: 'cs',
  },
});
